/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import {createElement, useContext} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {useStyleProperty} from '@EmailMakerReact/lib/email-maker-component-style-library';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import type {ConditionalControlDescriptor} from './conditional-control.types';

interface ConditionalControlInnerProps extends EmailMakerControlProps {
  descriptor: ConditionalControlDescriptor;
}

/**
 * Self-gates on the gating property's live value rather than a parent-driven `isVisible`: a plain
 * style edit does not re-render the parent panel, so a predicate there would only update on re-selection.
 */
function ConditionalControlInner({component, descriptor}: ConditionalControlInnerProps): ReactElement | null {
  const {editor} = useContext(emailMakerContext);

  const gatingValue = useStyleProperty(editor, component, descriptor.gatingProperty);

  // Read so the store subscription re-runs the predicate on every committed change.
  void gatingValue;

  if (!descriptor.predicate(component)) {
    return null;
  }

  return createElement(descriptor.control, {component});
}

export function makeConditionalControl(descriptor: ConditionalControlDescriptor): EmailMakerControl {
  return createDescriptorControl(ConditionalControlInner, descriptor);
}
